import { GraphQLPresignedUrlOutput } from "../models/output/graphql-presignedUrl-output";

  
  export function convertGraphQLPresignedUrlToString(input: GraphQLPresignedUrlOutput): string{
    return input.presignedUrl.toString()
  }